import helper from '@utils/helper';
import I18n from '@utils/i18n'

import { useBaseForm } from './useBaseForm';
import { useSellForm } from './useSellForm'
import { useValidata } from './useValidata';

export const useLimitSell = (params) => {
  const { coinDetail, assetCoinDetail, marginBalance, fetchMarginBalance, isLogin, close, tradeStore } = params;
  const { state: validState, updateValidState } = useValidata()
  const {
    form,
    updateBaseQty,
    updateOrderTotal,
    updateSlider,
    updatePrice,
    publicMarginSelected,
    loading,
    createTradeOrder,
    jumpLogin,
    handleMarginDisabled
  } = useBaseForm({ coinDetail, tradeStore, marginBalance, close, isLimit: true, priceKey: 'bid', fetchMarginBalance });
  const {
    renderMaxAvbl,
    renderSpotAvbl,
    renderEstimateBorrow,
    maxAvblAndSpotAvblRef
  } = useSellForm({ marginBalance, form, coinDetail, assetCoinDetail, isLimit: true })
  // 限价
  const onPriceChange = (e) => {
    updatePrice({ value: e?.target?.value })
    if (isLogin) {
      checkAmountIsValid()
      checkTotalIsValid()
      checkPriceValid()
      updateProgress()
    }
  }
  // 买入卖出
  const onBaseQtyChange = (e) => {
    const price = form.getFieldValue('price')
    updateBaseQty({ value: e?.target?.value, price })
    if (isLogin) {
      checkAmountIsValid()
      checkTotalIsValid()
      checkPriceValid()
      updateProgress()
    }
  }

  const updateProgress = () => {
    const limitPrice = form.getFieldValue('price');
    const orderAmount = form.getFieldValue('baseQty');

    const price = Number(limitPrice) < Number(coinDetail.bid) ? coinDetail.bid : Number(limitPrice);

    let maxSellAmountAvail = marginBalance?.()?.additional / price + Math.abs(marginBalance?.()?.unwindSellQty);
    const marginSelected = form.getFieldValue('marginSelected'); // 是否使用杠杆
    if (!marginSelected) {
      maxSellAmountAvail = maxSellAmountAvail < marginBalance?.()?.baseAvailable
        ? maxSellAmountAvail : marginBalance?.()?.baseAvailable
    }
    if (['USDT_USD', 'USDT_HKD'].includes(coinDetail?.coinCode)) {
      maxSellAmountAvail = Math.max(maxSellAmountAvail, marginBalance?.()?.baseAvailable)
    }
    const radio = maxSellAmountAvail > 0 ? Number(orderAmount) / Number(maxSellAmountAvail) : 0
    const progress = radio > 0 ? (radio >= 1 ? 100 : Math.ceil(radio * 100)) : 0;
    form.setFieldsValue({ progress })
  }
  // 成交额
  const onOrderTotalChange = (e) => {
    const price = form.getFieldValue('price')
    updateOrderTotal({ value: e?.target?.value, price })
    if (isLogin) {
      checkAmountIsValid()
      checkTotalIsValid()
      checkPriceValid()
      updateProgress()
    }
  }

  // 用户拉动滑杆
  const onSlider = (value) => {
    if (!isLogin) {
      jumpLogin()
      return
    }
    let price = form.getFieldValue('price')
    if (Number(price) < Number(coinDetail.bid)) {
      price = Number(coinDetail.bid)
    }
    const marginAvblSellAmount = (marginBalance?.()?.additional / price) + Math.abs(marginBalance?.()?.unwindSellQty)
    const marginSelected = form.getFieldValue('marginSelected'); // 是否使用杠杆
    const maxSellAvail = marginBalance?.()?.openMargin && marginSelected ? marginAvblSellAmount : marginBalance?.()?.baseAvailable;
    // if (marginAvblSellAmount < Number(marginBalance?.()?.baseAvailable) &&
    //   !['USDT_USD', 'USDT_HKD'].includes(coinDetail?.coinCode)) {
    //   maxSellAvail = marginAvblSellAmount
    // }

    updateSlider({ maxAvail: maxSellAvail, value, price: form.getFieldValue('price') })
    checkAmountIsValid()
    checkTotalIsValid()
  }

  const checkAmountIsValid = () => {
    if (!isLogin) {
      return
    }
    const orderAmount = form.getFieldValue('baseQty')
    let errorMsgAmount = ''
    if (typeof orderAmount === 'undefined' || !orderAmount) {
      errorMsgAmount = I18n.t('Mpg9o5vL')
      updateValidState({ errorMsgAmount, amountStatus: 'error' })
      return false
    }
    const limitPrice = form.getFieldValue('price')
    let maxAvailAmount = marginBalance?.()?.additional / coinDetail.bid + Math.abs(marginBalance?.()?.unwindSellQty)
    if (Number(limitPrice) > Number(coinDetail.bid)) {
      maxAvailAmount = marginBalance?.()?.additional / limitPrice + Math.abs(marginBalance?.()?.unwindSellQty)
    }
    const spotAvblAmount = marginBalance?.()?.baseAvailable ?? 0;
    const marginSelected = form.getFieldValue('marginSelected'); // 是否使用杠杆
    // 判断本金
    const avail = marginBalance?.()?.openMargin && marginSelected ? maxAvailAmount : spotAvblAmount;
    // if (maxAvailAmount < spotAvblAmount && !['USDT_USD', 'USDT_HKD'].includes(coinDetail?.coinCode)) {
    //   avail = maxAvailAmount
    // }
    const requestAmount = Number(orderAmount)
    const orderBaseMax = Number(limitPrice) ? Number(coinDetail.orderQuoteMax) / limitPrice : Number(coinDetail.orderBaseMax);
    if (orderBaseMax > 0 && Number(orderAmount) > orderBaseMax) {
      errorMsgAmount = I18n.t('oneMaxSellMessage', {
        amount: helper.formatFixNumString(orderBaseMax, coinDetail.tradeInputPrecision)
      })
      updateValidState({ errorMsgAmount, amountStatus: 'error' })
      return false
    }
    if (Number(requestAmount ?? 0) > Number(avail)) {
      errorMsgAmount = marginSelected ? I18n.t('CmkHjovb') : I18n.t('ZdTV8l92');
      updateValidState({ errorMsgAmount, amountStatus: 'error' })
      return false
    }
    if (Number(orderAmount) <= 0) {
      errorMsgAmount = I18n.t('minSellMessage', {
        amount: helper.formatFixNumString(coinDetail.orderBaseMin ?? 0, coinDetail.tradeInputPrecision)
      })
      updateValidState({ errorMsgAmount, amountStatus: 'error' })
      return false
    }
    if (coinDetail.bid && Number(requestAmount ?? 0) > Number(avail)) {
      errorMsgAmount = marginSelected ? I18n.t('CmkHjovb') : I18n.t('ZdTV8l92');
      updateValidState({ errorMsgAmount, amountStatus: 'error' })
      return false
    }
    updateValidState({ errorMsgAmount, amountStatus: 'success' })
    return true
  }

  const checkTotalIsValid = () => {
    if (!isLogin) {
      return
    }
    let errorMsgTotal = ''
    const orderQuoteMin = Number(coinDetail.orderQuoteMin)
    const orderTotal = form.getFieldValue('orderTotal')
    if (typeof orderTotal === 'undefined' || !orderTotal) {
      errorMsgTotal = I18n.t('q3DOozIm')
      updateValidState({ errorMsgTotal, totalStatus: 'error' })
      return false
    }
    if (Number(orderTotal) <= 0) {
      errorMsgTotal = I18n.t('minTotalMessage', {
        amount: helper.formatFixNumString(orderQuoteMin, coinDetail.tradeVolumePrecision)
      })
      updateValidState({ errorMsgTotal, totalStatus: 'error' })
      return false
    }

    if (Number(coinDetail.orderQuoteMin) > 0 && Number(orderTotal) < Number(coinDetail.orderQuoteMin)) {
      errorMsgTotal = I18n.t('minTotalMessage', {
        amount: helper.formatFixNumString(orderQuoteMin, coinDetail.tradeVolumePrecision)
      })
      updateValidState({ errorMsgTotal, totalStatus: 'error' })
      return false
    }

    const orderQuoteMax = Number(coinDetail.orderQuoteMax);

    if (orderQuoteMax > 0 && Number(orderTotal) > orderQuoteMax) {
      errorMsgTotal = I18n.t('oneMaxTotalMessage', {
        amount: helper.formatFixNumString(orderQuoteMax, coinDetail.tradePrecision)
      })
      updateValidState({ errorMsgTotal, totalStatus: 'error' })
      return false
    }

    updateValidState({ errorMsgTotal, totalStatus: 'success' })

    return true
  }

  // 用户停用/启用杠杆
  const onMarginSelected = async (checked) => {
    if (!isLogin) {
      jumpLogin()
      return
    }
    const spotAvbl = maxAvblAndSpotAvblRef.current.spotAvbl;
    const maxAvbl = maxAvblAndSpotAvblRef.current.maxAvbl;
    publicMarginSelected({ checked, isSpotAvblGreaterThanMaxAvbl: Number(spotAvbl) > Number(maxAvbl), onSlider })
  }

  // 杠杆的禁用状态 现货余额大于最大可用 并且弹框弹出过
  const getMarginDisabled = () => handleMarginDisabled({
    spotAvbl: maxAvblAndSpotAvblRef.current.spotAvbl, maxAvbl: maxAvblAndSpotAvblRef.current.maxAvbl
  })

  const checkPriceValid = () => {
    if (!isLogin) {
      return
    }
    const price = form.getFieldValue('price');
    let errorMsgPrice = ''
    if (typeof price === 'undefined' || !price) {
      errorMsgPrice = I18n.t('sRPgbi2T')
      updateValidState({ errorMsgPrice, priceStatus: 'error' })
      return false
    }
    updateValidState({ errorMsgPrice, priceStatus: 'success' })
    return true
  }

  const onFinish = async (values) => {
    if (!submitValidata()) {
      return
    }
    createTradeOrder({
      order_type: 'limit',
      side: 'sell',
      price: form.getFieldValue('price')
    })
  }

  const submitValidata = () => {
    return [checkPriceValid(), checkAmountIsValid(), checkTotalIsValid()].every(res => res)
  }

  return {
    form,
    onPriceChange,
    onBaseQtyChange,
    onOrderTotalChange,
    onSlider,
    renderMaxAvbl,
    renderSpotAvbl,
    renderEstimateBorrow,
    onMarginSelected,
    getMarginDisabled,
    loading,
    onFinish,
    validState,
    updatePrice
  }
}
